import ControlGroup from '../ControlGroup';
import type FormHandler from '../FormHandler';

export enum Field {
  Street1 = 'Street1',
  Street2 = 'Street2',
  CountryId = 'CountryId',
  StateId = 'StateId',
  City = 'City',
  PostalCode = 'PostalCode',
}

export type AddressFields = {
  [Field.Street1]: string,
  [Field.Street2]: string,
  [Field.CountryId]: string,
  [Field.StateId]: string,
  [Field.City]: string,
  [Field.PostalCode]: string,
};

export interface Address {
  address1: string; // TODO Change this to street1, street2, & stateId
  address2: string;
  city: string;
  state: string;
  postalCode: string;
  countryId: string;
}

export default class AddressForm {
  street1: ControlGroup;

  street2?: ControlGroup;

  country: ControlGroup;

  state: ControlGroup;

  city: ControlGroup;

  postalCode: ControlGroup;

  $container: HTMLElement | undefined;

  constructor(formHandler: FormHandler, fields: AddressFields, $container?: HTMLElement) {
    this.city = formHandler.getControlGroup(fields[Field.City])!;
    this.state = formHandler.getControlGroup(fields[Field.StateId])!;
    this.country = formHandler.getControlGroup(fields[Field.CountryId])!;
    this.postalCode = formHandler.getControlGroup(fields[Field.PostalCode])!;
    this.street1 = formHandler.getControlGroup(fields[Field.Street1])!;
    this.street2 = formHandler.getControlGroup(fields[Field.Street2]);
    this.$container = $container;
  }

  getAddress(): Address {
    return {
      address1: this.street1.input.value || '',
      address2: this.street2 ? this.street2.input.value : '',
      city: this.city.input.value || '',
      state: this.state.input.value || '',
      countryId: this.country.input.value || '',
      postalCode: this.postalCode.input.value || '',
    };
  }

  updateAddress(address: Address) {
    this.country.input.value = address.countryId;
    this.street1.input.value = address.address1;
    this.city.input.value = address.city;
    this.state.input.value = address.state;
    this.postalCode.input.value = address.postalCode;

    if (this.street2) {
      this.street2.input.value = address.address2;
    }
  }
}
